import{ARRAY_SEPARATOR,ESCAPE,TOKEN_SEPARATOR}from"../tokens/escape.js";
import{getStringTokenType}from"../tokens/main.js";

import{parseEscape}from"./escape.js";



export const parseQueryString=(queryString)=>{
const state=getInitialState();


for(;state.index<=queryString.length;state.index+=1){
const char=queryString[state.index];


if(char===ESCAPE){
parseEscape(state,queryString)
}else if(char===ARRAY_SEPARATOR||state.index===queryString.length){
addQueryArray(state)
}else if(char===TOKEN_SEPARATOR){
addToken(state)
}else{
state.chars+=char
}
}

return state.arrays
};

const getInitialState=()=>{
const state={arrays:[],index:0};
resetQueryArrayState(state);
resetTokenState(state);
return state
};

const addQueryArray=(state)=>{
if(hasNoQueryArray(state)){
return
}

if(!hasOnlyDots(state)){
addToken(state)
}


state.arrays.push(state.array);
resetQueryArrayState(state)
};


const hasNoQueryArray=(state)=>
state.firstToken&&state.chars.length===0&&state.array.length===0;

const resetQueryArrayState=(state)=>{
state.array=[];
state.firstToken=true;
state.onlyDots=true
};

const addToken=(state)=>{
if(handleLeadingDot(state)){
return
}

state.onlyDots=hasOnlyDots(state);
const tokenType=getStringTokenType(state.chars,state.isProp);
const token=tokenType.normalize(tokenType.parse(state.chars));

state.array.push(token);
resetTokenState(state)
};








const hasOnlyDots=(state)=>state.onlyDots&&state.chars.length===0;



const handleLeadingDot=(state)=>{
if(!state.firstToken){
return false
}

state.firstToken=false;
return state.chars.length===0
};

const resetTokenState=(state)=>{
state.isProp=false;
state.chars=""
};